import { defineMessage } from 'services/localization';

export const messages = {
    kbDropdownText: defineMessage('knowledge_base'),
    videosDropdownText: defineMessage('howto_videos'),
    trainingDropdownText: defineMessage('training_package'),
    trainingTitle: defineMessage('whats_included'),
    trainingDescription: defineMessage('bulletrequirements_and__ustomised_to_your_needs'),
    contactSales: defineMessage('contact_us'),
    hideButtonText: defineMessage('hide'),
};
